import { HttpEvent, HttpRequest, HttpHandlerFn, HttpInterceptorFn } from '@angular/common/http';
import { Observable, catchError, finalize, shareReplay, switchMap, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { inject } from '@angular/core';
import { SKIP_AUTH_REFRESH } from './auth-http-context';
import { environment } from '../../environments/environment';

let refreshTokenRequest$: Observable<any> | null = null;

export const authTokenInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const excludedUrls = ['/auth/', '/users/logout', '/api/v1/', '/translate/v2'];
  const authService = inject(AuthService);

  if (excludedUrls.some(excludedPath => req.url.includes(excludedPath))) {
    return next(req);
  }

  if (!req.url.startsWith(environment.API_URL)) {
    return next(req);
  }

  if (req.context.get(SKIP_AUTH_REFRESH)) {
    return next(req);
  }

  if (refreshTokenRequest$) {
    return refreshTokenRequest$.pipe(
      switchMap(() => {
        return next(req);
      }),
      catchError((err) => {
        console.error('Session refresh failed:', err);
        authService.forceLogout('Token refresh failed');
        return throwError(() => err);
      })
    );
  }


  return next(req).pipe(
    catchError((error) => {
      if (error.status === 401) {
        if (authService.isLogoutInProgress()) {
          return throwError(() => error);
        }

        if (!refreshTokenRequest$) {
          refreshTokenRequest$ = authService.refreshToken().pipe(

            shareReplay({
              bufferSize: 1,
              refCount: true
            }),
            finalize(() => {
              refreshTokenRequest$ = null;
            })
          );
        }

        return refreshTokenRequest$.pipe(
          switchMap(() => {
            return next(req);
          }),
          catchError((refreshError) => {
            console.error('Session refresh failed:', refreshError);
            authService.forceLogout('Session refresh failed');
            return throwError(() => refreshError);
          })
        );
      }
      return throwError(() => error);
    })
  );
};
